import type { LucideIcon } from 'lucide-react';
import {
  ArrowDown, ArrowUp, BarChart3, Bandage, ChevronRight, Cloud, CloudRain, ClipboardList, Download, ExternalLink,
  FlaskConical, Gauge, Home, Info, Menu, Newspaper, Plus, Radio, RefreshCw, Settings, Snowflake, Sparkles, Sun,
  Target, Thermometer, Trash2, TriangleAlert, User, Users, Wallet, Wind, Workflow, X,
} from 'lucide-react';

/**
 * The app's icon set: Lucide at a 1.75px stroke. The names are the app's own,
 * so a page asks for "the ledger icon" rather than a specific drawing, and the
 * set can change here without touching a page.
 */

type P = { className?: string; size?: number };

const make = (Icon: LucideIcon) => {
  const Wrapped = ({ className, size = 17 }: P) => (
    <Icon size={size} strokeWidth={1.75} className={className} aria-hidden />
  );
  Wrapped.displayName = Icon.displayName;
  return Wrapped;
};

export const IconTarget = make(Target);
export const IconCross = make(Plus);
export const IconBandage = make(Bandage);
export const IconRoster = make(Users);
export const IconNews = make(Newspaper);
export const IconFlask = make(FlaskConical);
export const IconLedger = make(Wallet);
export const IconGear = make(Settings);
export const IconGauge = make(Gauge);
export const IconRefresh = make(RefreshCw);
export const IconWarn = make(TriangleAlert);
export const IconInfo = make(Info);
export const IconClose = make(X);
export const IconMenu = make(Menu);
export const IconExternal = make(ExternalLink);
export const IconPlus = make(Plus);
export const IconTrash = make(Trash2);
export const IconDownload = make(Download);
export const IconSpark = make(Sparkles);
export const IconChevron = make(ChevronRight);
export const IconWind = make(Wind);
export const IconRain = make(CloudRain);
export const IconSnow = make(Snowflake);
export const IconSun = make(Sun);
export const IconCloud = make(Cloud);
export const IconDome = make(Home);
export const IconThermometer = make(Thermometer);
export const IconFeed = make(Radio);
export const IconChart = make(BarChart3);
export const IconArrowUp = make(ArrowUp);
export const IconArrowDown = make(ArrowDown);
export const IconPlayer = make(User);
export const IconLineup = make(ClipboardList);
export const IconFlow = make(Workflow);
